<template>
  <NfErrorMessage>
    <span :class="[label ? 'p-float-label' : '']">
      <slot></slot>
      <label v-if="label" :for="inputName">{{ label }}</label>
    </span>
  </NfErrorMessage>
</template>

<script lang="ts">
export interface NfInputFloatLabelProps {
  inputName: string; 
  label?: string;
}

// Default Export, used for IDE auto-importing only
export default {
  name: 'NfInputFloatLabel'
}
</script>

<script lang="ts" setup>
import NfErrorMessage from '@/components/form/NfErrorMessage.vue';

// @todo Deprecated / Legacy Code
// Define Component
defineProps<NfInputFloatLabelProps>();
</script>

<style scoped></style>
